import {loadState} from '../../localStorage';

const persistedState = loadState();

let defaultState = Object.assign({theme: {}}, persistedState.config);
export default (state = defaultState, action) => {
	switch (action.type) {
		default:
			return state;
	}

}

